import React from 'react';
import PropTypes from 'prop-types';
import { useI18n } from './I18n';

var Message = function Message(props) {
  var id = props.id,
      params = props.params,
      rawHtml = props.rawHtml;

  var _useI18n = useI18n(),
      getMessage = _useI18n.getMessage;

  var message = getMessage(id, params, props["default"]);
  var messages = message instanceof Array ? message : [message];
  var ElementType = props.as || React.Fragment;
  return /*#__PURE__*/React.createElement(React.Fragment, null, messages.map(function (message, index) {
    if (rawHtml) {
      return /*#__PURE__*/React.createElement(ElementType, {
        key: index,
        dangerouslySetInnerHTML: {
          __html: message
        }
      });
    }

    return /*#__PURE__*/React.createElement(ElementType, {
      key: index
    }, message);
  }));
};

Message.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  params: PropTypes.object,
  rawHtml: PropTypes.bool,
  "default": PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType])
} : {};
Message.defaultProps = {};
export default Message;